import { Routes, Route } from "react-router-dom";
import { PublicRoute, ProtectedRoute, PaidRoute, AdminRoute } from "./routes/routes";
import { TranslationProvider } from "./i18n/TranslationProvider";
import { useAuth } from "./contexts/AuthContext";

import Header from "./components/header/Header";
import Landing from "./features/Landing";
import Login from "./features/authentication/Login";
import Register from "./features/onboarding/Register";
import ForgotPassword from "./features/authentication/ForgotPassword";
import ResetPassword from "./features/authentication/ResetPassword";
import IISSDecisionFlow from "./features/questionnaire/IISSDecisionFlow";
import Athletes from "./features/athletes/Athletes";
import AddNewAthletes from "./features/athletes/AddNewAthletes";
import Payment from "./features/onboarding/Payment";
import PaymentProcessing from "./features/onboarding/PaymentProcessing";
import Invoice from "./features/billing/Invoice";
import NotFound from "./features/NotFound";
import AdminUpload from "./features/athletes/AdminUpload";
import ReviewRoster from "./features/athletes/ReviewRoster";
import EditRoster from "./features/athletes/EditRoster";
import EMRDashboard from "./features/emr/EMRDashboard";
import AthleteSignupForm from "./features/athletes/components/AthleteSignUpForm";
import HelpPage from "./features/help/Help";
import FeatureSuggestionPage from "./features/help/FeatureSuggestion";
import AssignLicenses from "./features/admin/AssignLicences";

function App() {
    const { userId } = useAuth();

    return (
        <TranslationProvider user={userId ? { userId } : null}>
            <Header />
            <Routes>
                <Route element={<PublicRoute />}>
                    <Route path="/" element={<Landing />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route
                        path="/forgot-password"
                        element={<ForgotPassword />}
                    />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/admin/upload" element={<AdminUpload />} />
                    <Route
                        path="/add-new-athletes/review"
                        element={<ReviewRoster />}
                    />
                </Route>
                <Route element={<PaidRoute />}>
                    <Route path="/payment" element={<Payment />} />
                </Route>

                {/* TEMP: preview-only route for PaymentProcessing, no auth/plan-state gating yet.
                    Replace with the real conditional route once the "plan selected, awaiting
                    payment" state is wired up — remove this line when that lands. */}
                <Route path="/payment-processing-preview" element={<PaymentProcessing />} />
                <Route element={<ProtectedRoute />}>
                    <Route element={<AdminRoute />}>
                        <Route path="/invoice" element={<Invoice />} />
                        <Route path="/licenses" element={<AssignLicenses />} />
                    </Route>

                    {/* If user selects SPORTS product type */}
                    <Route path="/athletes" element={<Athletes />} />
                    <Route path="/athletes/edit" element={<EditRoster />} />
                    <Route path="/iiss-flow" element={<IISSDecisionFlow />} />
                    <Route
                        path="/add-new-athletes"
                        element={<AddNewAthletes />}
                    />
                    {/* If user selects EMR product type */}
                    <Route path="/emr-dashboard" element={<EMRDashboard />} />
                </Route>

                 {/* Fully public — no auth needed */}
                <Route path="/athlete-signup/:token" element={<AthleteSignupForm />} />
                <Route path="/help" element={<HelpPage />} />
                <Route
                    path="/feature-suggestion"
                    element={<FeatureSuggestionPage />}
                />

                <Route path="*" element={<NotFound />} />
            </Routes>
        </TranslationProvider>
    );
}

export default App;